import { AuthenticationService } from './../../../services/authentication.service';
import { CatalogsService } from './../../../services/catalogs/catalogs.service';
import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ReactiveFormsModule, FormsModule, FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ToasterModule, ToasterService, Toast } from 'angular5-toaster';
import { StorageService } from '../../../services/storage.service';
import { User } from '../../../models/user';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-changepassword',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  providers: [CatalogsService, AuthenticationService]
})
export class ChangePasswordComponent implements OnInit {

  public user: User;
  closeResult: string;
  busy: boolean = false;
  public errors = null;
  password1;
  password2;
  email1;
  email2;
  flagCaracter = true;
  modalMensaje;
  myform: FormGroup;
  logForm: FormGroup;
  email: string;
  titulo;
  respuesta;

  passwordCambiado;
  ingresarNuevaPassword;
  direccionaCambiada;
  ingresarNuevaDireccion;
  constructor(
    private translate: TranslateService,
    public formBuilder: FormBuilder,
    private storageService: StorageService,
    private _router: Router,
    private catalogos: CatalogsService,
    public activeModal: NgbActiveModal,
    private toasterService: ToasterService,
    private modalService: NgbModal,
    private authenticationService: AuthenticationService
  ) {
    this.translate.get('texto.passwordCambiado').subscribe(
      text => {
        this.passwordCambiado = text;
      });

    this.translate.get('texto.ingresarNuevaPassword').subscribe(
      text => {
        this.ingresarNuevaPassword = text;
      });

    this.translate.get('texto.direccionCambiada').subscribe(
      text => {
        this.direccionaCambiada = text;
      });

    this.translate.get('texto.ingresarNuevaDireccion').subscribe(
      text => {
        this.ingresarNuevaDireccion = text;
      });
  }

  ngOnInit() {
    this.noBack();
    this.user = this.storageService.getCurrentUser();

    this.logForm = this.formBuilder.group({
      email1: ['', Validators.compose([Validators.required,
      Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$'),
      Validators.minLength(1)])],
      email2: ['', Validators.compose([Validators.required,
      Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$'),
      Validators.minLength(1)])]
    });

  }

  noBack() {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
  }

  closeModal() {
    this.activeModal.close('cancelar');
  }

  // revisarPass(password1) {
  //   for (let i = 0; i < password1.length; i++) {
  //     if (password1[i] === '#') {
  //       this.flagCaracter = false;
  //       break;
  //     } else {
  //       this.flagCaracter = true;
  //     }
  //   }

  // }

  checkPasswordRules(value: string) {
    const val = value || '';

    return {
      minLength: val.length < 14,
      noUppercase: !/[A-Z]/.test(val),
      noLowercase: !/[a-z]/.test(val),
      noNumber: !/[0-9]/.test(val),
      noSpecial: !/[.*@#&!%_+\/\-?^${}()]/.test(val)
    };
  }

  get passwordErrors() {
    const errors = this.checkPasswordRules(this.password1);
    
    // si no hay errores (todos son false), se devuelve null
    return Object.values(errors).includes(true) ? errors : null;
  }

  cambiarPassword(mensaje) {
    const password1 = this.password1;
    const password2 = this.password2;
    const idUser = this.user.id;
    this.busy = true;

    this.authenticationService.cambiarPassword(idUser, password2).subscribe(
      data => {
        this.busy = false;
        this.titulo = this.passwordCambiado;
        this.respuesta = this.ingresarNuevaPassword;
        this.activeModal.close();
        this.openMensaje(mensaje);
      },
      err => {
        this.busy = false;
        if (err.status === 401) {
          this.storageService.openLogout();
        } 
      },
    );
  }

  cambiarEmail(mensaje) {
    const email1 = this.email1;
    const email2 = this.email2;
    const idUser = this.user.id;
    this.busy = true;

    this.authenticationService.cambiarCorreo(idUser, email2).subscribe(
      data => {
        this.busy = false;
        this.titulo = this.direccionaCambiada;
        this.respuesta = this.ingresarNuevaDireccion;
        this.activeModal.close();
        this.openMensaje(mensaje);
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        } 
      },
    );
  }

  reiniciar() {
    this.modalMensaje.close();
    this.authenticationService.cerrarSesion().subscribe(
      data => {
        this.storageService.passwordChanged();
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        } 
      },
    );
  }

  openMensaje(mensaje) {
    this.modalMensaje = this.modalService.open(mensaje, { centered: true });
    this.modalMensaje.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReasonFiltersOC(reason)}`;
    });
  }

  private getDismissReasonFiltersOC(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }


}






// WEBPACK FOOTER //
// ./src/app/pages/home/change-password/change-password.component.ts